import {
  NfseAmbiente,
  NfseEmissaoStatus,
  NfseEmitenteSituacao,
  NfseVerificacaoCodigo,
} from '../../../../../types/nfseEmissao';

export const NFSE_EMISSAO_PATH = '/modulesHome/supervisor/nfse-emissao';

export const NFSE_PATHS = {
  painel: NFSE_EMISSAO_PATH,
  emitir: `${NFSE_EMISSAO_PATH}/emitir`,
  notas: `${NFSE_EMISSAO_PATH}/notas`,
  empresas: `${NFSE_EMISSAO_PATH}/empresas`,
  certificados: `${NFSE_EMISSAO_PATH}/certificados`,
};

// ?emitente= abre a tela de certificados com o envio daquela empresa já escolhido.
export const certificadosPath = (emitenteId?: number) =>
  emitenteId ? `${NFSE_PATHS.certificados}?emitente=${emitenteId}` : NFSE_PATHS.certificados;

export const emitirPath = (emitenteId?: number) =>
  emitenteId ? `${NFSE_PATHS.emitir}?emitente=${emitenteId}` : NFSE_PATHS.emitir;

export const editarPath = (emissaoId: number) => `${NFSE_PATHS.emitir}/${emissaoId}`;

// Nova nota com tomador, serviço e valores de outra (Duplicar). Não reaproveita o número.
export const duplicarPath = (emissaoId: number) => `${NFSE_PATHS.emitir}?duplicar=${emissaoId}`;

export const notaPath = (emissaoId: number) => `${NFSE_PATHS.notas}/${emissaoId}`;

// Ações cadastradas na tela de permissões. O backend confere as mesmas.
export const NFSE_ACOES = {
  emitir: 'emitir',
  cancelar: 'cancelar',
  certificado: 'certificado',
};

export const STATUS_LABEL: Record<NfseEmissaoStatus, string> = {
  rascunho: 'Rascunho',
  enviando: 'Enviando',
  autorizada: 'Autorizada',
  rejeitada: 'Rejeitada',
  cancelada: 'Cancelada',
  substituida: 'Substituída',
};

export const STATUS_COLOR: Record<NfseEmissaoStatus, string> = {
  rascunho: 'gray',
  enviando: 'blue',
  autorizada: 'green',
  rejeitada: 'red',
  cancelada: 'gray',
  substituida: 'yellow',
};

export const SITUACAO_LABEL: Record<NfseEmitenteSituacao, string> = {
  liberado: 'Pode emitir',
  municipio_nao_aderente: 'Município não aderente',
  sem_ibge: 'Sem código IBGE',
  sem_certificado: 'Sem certificado',
  certificado_vencido: 'Certificado vencido',
  procuracao_vencida: 'Procuração vencida',
};

export const SITUACAO_COLOR: Record<NfseEmitenteSituacao, string> = {
  liberado: 'green',
  municipio_nao_aderente: 'orange',
  sem_ibge: 'gray',
  sem_certificado: 'gray',
  certificado_vencido: 'red',
  procuracao_vencida: 'red',
};

export const AMBIENTE_LABEL: Record<NfseAmbiente, string> = {
  homologacao: 'Homologação',
  producao: 'Produção',
};

export const VERIFICACAO_LABEL: Record<NfseVerificacaoCodigo, string> = {
  RN14: 'Município aderente e IBGE conferido',
  RN15: 'Certificado digital válido',
  RN16: 'Número ainda não emitido',
  XSD: 'Leiaute da DPS (XSD v1.01)',
};

// Códigos de negócio que o backend devolve com HTTP 422 (PDD, seção 5).
export const ERRO_NEGOCIO = {
  municipioNaoAderente: 'MUNICIPIO_NAO_ADERENTE',
  certificadoVencido: 'CERTIFICADO_VENCIDO',
  numeroJaEmitido: 'NUMERO_JA_EMITIDO',
};

export const TRIB_ISSQN_OPCOES = [
  { value: '1', label: '1 · Operação tributável' },
  { value: '2', label: '2 · Imunidade' },
  { value: '3', label: '3 · Exportação de serviço' },
  { value: '4', label: '4 · Não incidência' },
];

export const TP_RET_ISSQN_OPCOES = [
  { value: '1', label: '1 · Não retido' },
  { value: '2', label: '2 · Retido pelo tomador' },
  { value: '3', label: '3 · Retido pelo intermediário' },
];

// Operação com o exterior (Anexo I, grupo comExt). Os valores 0/00/9 de "desconhecido"
// só valem no compartilhamento pelo município: a Sefin rejeita (E0333, E0341, E0343, E0345).
export const NAO_NIF_OPCOES = [
  { value: '1', label: '1 · Dispensado do NIF' },
  { value: '2', label: '2 · Não exigência do NIF' },
];

export const MODO_PRESTACAO_OPCOES = [
  { value: '1', label: '1 · Transfronteiriço' },
  { value: '2', label: '2 · Consumo no Brasil' },
  { value: '3', label: '3 · Movimento temporário de pessoas físicas' },
  { value: '4', label: '4 · Consumo no exterior' },
];

export const VINCULO_OPCOES = [
  { value: '0', label: '0 · Sem vínculo' },
  { value: '1', label: '1 · Controlada' },
  { value: '2', label: '2 · Controladora' },
  { value: '3', label: '3 · Coligada' },
  { value: '4', label: '4 · Matriz' },
  { value: '5', label: '5 · Filial ou sucursal' },
  { value: '6', label: '6 · Outro vínculo' },
];

// Código de 3 dígitos da tabela de moedas do Banco Central (Siscomex).
export const MOEDA_OPCOES = [
  { value: '220', label: 'USD · Dólar dos EUA' },
  { value: '978', label: 'EUR · Euro' },
  { value: '540', label: 'GBP · Libra esterlina' },
  { value: '706', label: 'ARS · Peso argentino' },
  { value: '745', label: 'UYU · Peso uruguaio' },
  { value: '715', label: 'CLP · Peso chileno' },
  { value: '741', label: 'MXN · Peso mexicano' },
  { value: '165', label: 'CAD · Dólar canadense' },
  { value: '150', label: 'AUD · Dólar australiano' },
  { value: '425', label: 'CHF · Franco suíço' },
  { value: '470', label: 'JPY · Iene' },
  { value: '795', label: 'CNY · Iuan renminbi' },
];

export const MEC_PRESTADOR_OPCOES = [
  { value: '01', label: '01 · Nenhum' },
  { value: '02', label: '02 · ACC' },
  { value: '03', label: '03 · ACE' },
  { value: '04', label: '04 · BNDES-Exim Pós-Embarque' },
  { value: '05', label: '05 · BNDES-Exim Pré-Embarque' },
  { value: '06', label: '06 · FGE' },
  { value: '07', label: '07 · PROEX Equalização' },
  { value: '08', label: '08 · PROEX Financiamento' },
];

export const MEC_TOMADOR_OPCOES = [
  { value: '01', label: '01 · Nenhum' },
  { value: '02', label: '02 · Adm. Pública e Repr. Internacional' },
  { value: '03', label: '03 · Aluguéis e arrend. mercantil de máquinas e equipamentos' },
  { value: '04', label: '04 · Arrend. mercantil de aeronave para transporte aéreo público' },
  { value: '05', label: '05 · Comissão a agentes externos na exportação' },
  { value: '06', label: '06 · Armazenagem, mov. e transporte de carga no exterior' },
  { value: '07', label: '07 · Eventos FIFA (subsidiária)' },
  { value: '08', label: '08 · Eventos FIFA' },
  { value: '09', label: '09 · Fretes, arrend. de embarcações ou aeronaves e outros' },
  { value: '10', label: '10 · Material aeronáutico' },
  { value: '11', label: '11 · Promoção de bens no exterior' },
  { value: '12', label: '12 · Promoção de destinos turísticos brasileiros' },
  { value: '13', label: '13 · Promoção do Brasil no exterior' },
  { value: '14', label: '14 · Promoção de serviços no exterior' },
  { value: '15', label: '15 · RECINE' },
  { value: '16', label: '16 · RECOPA' },
  { value: '17', label: '17 · Registro e manutenção de marcas, patentes e cultivares' },
  { value: '18', label: '18 · REICOMP' },
  { value: '19', label: '19 · REIDI' },
  { value: '20', label: '20 · REPENEC' },
  { value: '21', label: '21 · REPES' },
  { value: '22', label: '22 · RETAERO' },
  { value: '23', label: '23 · RETID' },
  { value: '24', label: '24 · Royalties, assistência técnica, científica e assemelhados' },
  { value: '25', label: '25 · Avaliação da conformidade (Acordos da OMC)' },
  { value: '26', label: '26 · ZPE' },
];

export const MOV_TEMP_BENS_OPCOES = [
  { value: '1', label: '1 · Não' },
  { value: '2', label: '2 · Vinculada a Declaração de Importação' },
  { value: '3', label: '3 · Vinculada a Declaração de Exportação' },
];

// Motivos de cancelamento do Anexo II (cMotivo). Conferir a lista final no anexo.
export const MOTIVOS_CANCELAMENTO = [
  { value: '1', label: '1 · Erro na emissão' },
  { value: '2', label: '2 · Serviço não prestado' },
  { value: '9', label: '9 · Outros' },
];
